<template>
  <div>
    <div class="main">
      <div class="content-container">
        <div class="content-wrapper">
          <div class="content-banner-box">
            <div class="banner-box">
              <div class="banner-box-title">一站式出行行业数字化解决方案服务商</div>
            </div>
          </div>
          <div class="form_box">
              
          <div class="content-box">
            <div class="content-tab">
              <div :class="{ 'is-active': isActive == 1 }" @click="handleTab(1)">
                密码登录
              </div>
              <div :class="{ 'is-active': isActive == 2 }" @click="handleTab(2)">
                验证登录
              </div>
            </div>
            <!-- 表单块 -->
            <form class="form-container" :ref="formDataRef">
              <template v-if="isActive === 1">
                <div class="form-container-item">
                  <div class="item-content item_content_mg_lf">
                    <!-- <label class="item-label item_label_wd">用户名：</label> -->
                    <div class="item-input-box">
                      <input
                        v-model="formData.username"
                        maxlength="20"
                        type="text"
                        prop="username"
                        placeholder="用户名"
                        :class="{ errorRules: modelControl['username'] }"
                        class="input__inner"
                      />
                      <div class="error-message" v-if="modelControl['username']">
                        {{ modelControl["username"] }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-container-item">
                  <div class="item-content item_content_mg_lf">
                    <!-- <label class="item-label item_label_wd">密码：</label> -->
                    <div class="item-input-box">
                      <input
                        v-model="formData.password"
                        maxlength="20"
                        type="password"
                        prop="password"
                        placeholder="密码"
                        :class="{ errorRules: modelControl['password'] }"
                        class="input__inner"
                      />
                      <div class="error-message" v-if="modelControl['password']">
                        {{ modelControl["password"] }}
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <!-- <div class="form-container"> -->
                <div class="form-container-item">
                  <div class="item-content item_content_mg_lf">
                    <!-- <label class="item-label item_label_wd">手机号：</label> -->
                    <div class="item-input-box">
                      <input
                        v-model="formData.phone"
                        maxlength="11"
                        type="text"
                        placeholder="手机号"
                        prop="phone"
                        :class="{ errorRules: modelControl['phone'] }"
                        class="input__inner"
                      />
                      <div class="error-message" v-if="modelControl['phone']">
                        {{ modelControl["phone"] }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-container-item">
                  <div class="item-content item_content_mg_lf">
                    <!-- <label class="item-label item_label_wd">验证码：</label> -->
                    <div class="item-input-box">
                      <div class="flex-between position_relative">
                        <input
                          v-model="formData.code"
                          maxlength="6"
                          type="text"
                          prop="code"
                          placeholder="验证码"
                          :class="{ errorRules: modelControl['code'] }"
                          class="input__inner"
                        />
                        <button
                          class="getcode-button"
                          :class="{ isSendCodeActive: isSendCodeActive }"
                          @click.prevent="handleGetCode"
                          :disabled="isSendCodeActive"
                        >
                          {{ sendCodeText }}
                        </button>
                      </div>
                      <div class="error-message" v-if="modelControl['code']">
                        {{ modelControl["code"] }}
                      </div>
                    </div>
                  </div>
                </div>
                <!-- </div> -->
              </template>
            </form>
            <div class="form-container-item">
              <div class="item-content item_content_mg_lf">
                <!-- <label class="item-label item_label_wd"></label> -->
                <button class="form-button" @click.prevent="handleClick">登录</button>
              </div>
            </div>
            <div class="form-container-item">
              <div class="item-content item_content_mg_lf">
                <!-- <label class="item-label item_label_wd"></label> -->
                <div class="login-footer-container flex-between">
                  <div>
                    没有账号？
                    <router-link to="/register" class="aLinkblue">去注册</router-link>
                  </div>
                  <router-link to="/passwordRetrieval" class="aLinkblue"
                    >找回密码</router-link
                  >
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import { driverJoin } from '@/api/api'
import { mapState, mapActions } from "vuex";
import Schema from "async-validator";
export default {
  data() {
    return {
      userStorageName: "ikaiWebUser",
      isErr: false,
      isSuccess: false,
      isSubmit: true,
      formData: {
        phone: "",
        serverArea: "",
        username: "",
        password: "",
        code: "",
        model: "",
      },
      isActive: 1,
      sendCodeText: "获取验证码",
      isSendCodeActive: false,
      rules: {
        username: [
          { required: true, message: "请输入用户名" },
          {
            required: true,
            pattern: /^[a-zA-Z0-9]{6,20}$/,
            min: 6,
            max: 20,
            message: "长度为6~20位, 可以使用数字、大小写字母",
          },
        ],
        phone: [
          { required: true, message: "请输入手机号" },
          {
            required: true,
            pattern: /^1[3456789]\d{9}$/,
            message: "请输入正确的手机号",
          },
        ],
        password: [
          { required: true, message: "请输入密码" },
          {
            required: true,
            pattern: /([=.*^a-zA-Z0-9]){6,20}/,
            min: 6,
            max: 20,
            message: "长度为6~20位，可以使用数字、大小写字母、特殊字符",
            trigger: "blur",
          },
        ],
        code: [{ required: true, pattern: /^\d{6}$/, message: "请输入验证码" }],
      },
      formDataRef: "formDataRef",
      modelControl: {},
      formError: {},
    };
  },
  computed: {},
  methods: {
    ...mapActions(["login", "lSendCode", "getUserInfo"]),
    handleTab(val) {
      this.isActive = val;
    },
    handleGetCode() {
      if (!this.formData.phone || this.formData.phone.length !== 11) return;
      let data = {
        phone: this.formData.phone,
      };
      let _this = this;
      this.lSendCode(data)
        .then((res) => {
          if (!res) {
            // this.$notify({
            //   type: "success",
            //   title: "成功",
            //   message: "发送成功",
            // });
            this.$toast({
              title: "成功",
              content: "发送成功",
              type: "success",
            });
            this.isSendCodeActive = true;
            let num = 60;
            let timer = null;
            let sendCodeText = "60S";
            timer = setInterval(() => {
              if (num === 0) {
                clearInterval(timer);
                _this.sendCodeText = "获取验证码";
                _this.isSendCodeActive = false;
              } else {
                num--;
                sendCodeText = `${num}S`;
                _this.sendCodeText = sendCodeText;
              }
            }, 1000);
          }
        })
        .catch((err) => {
          this.isSendCodeActive = false;
        });
    },
    handleClick() {
      let errors = this.rulesFunc(this.formDataRef, this.formData, this.rules);
      errors
        .then((v) => {
          if (!v) {
            console.log("通过");
            let data = Object.assign({}, this.formData, {
              loginCodeType: this.isActive,
            });
            this.login(data)
              .then((res) => {
                // localStorage.setItem(this.userStorageName, this.formData.username)
                if (res.status == 200) {
                  // this.$message.success("登录成功");
                  this.$toast({
                    title: "",
                    content: "登陆成功",
                    type: "success",
                  });
                  this.getUserInfo();
                  // this.$router.push({name: 'index', params: {phone: '123'}})
                  this.$router.push({
                    path: "/index",
                  });
                  // window.location.reload();
                }
              })
              .finally(() => {});
          } else {
            console.log("不通过");
          }
        })
        .catch((e) => {});
    },
    handleBlurRules(e) {
      const prop = e.target.attributes.prop.value;
      if (!prop) {
        return false;
      }
      this.rulesFunc(this.formDataRef, this.formData, this.rules);
    },
    rulesFunc(formDataRef, formData, rules) {
      let fieldsArr = [];
      let newfields = {};
      for (let key1 of this.$refs[formDataRef]) {
        let attributesArr = key1.getAttribute("prop");
        fieldsArr.push(attributesArr);
      }
      fieldsArr.forEach((el) => {
        if (this.rules[el]) {
          newfields[el] = rules[el];
        }
      });
      this.validator = new Schema(newfields);
      let errors = this.validator
        .validate(formData)
        .then((value) => {
          // 校验通过
          this.modelControl = {};
        })
        .catch(({ errors, fields }) => {
          // this.modelControl[prop] = fields[prop][0].message;
          let modelControl = {};
          for (let key in fields) {
            modelControl[key] = fields[key][0].message;
          }
          this.modelControl = modelControl;
          return errors;
        });
      return errors;
    },
  },
  watch: {},
  created() {},
};
</script>
<style scoped lang="scss">

</style>